// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-billing-customer-list .list-row-red {
  background-color: var(--fi-color-red);
}
.customer-billing-customer-list .list-row-red:hover {
  background-color: var(--fi-color-red) !important;
}
.customer-billing-customer-list .list-row-blue {
  background-color: var(--fi-color-blue);
}
.customer-billing-customer-list .list-row-blue:hover {
  background-color: var(--fi-color-blue) !important;
}
.customer-billing-customer-list .list-row-dark-blue {
  background-color: var(--fi-color-dark-blue);
}
.customer-billing-customer-list .list-row-dark-blue:hover {
  background-color: var(--fi-color-dark-blue) !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/customer-billing/customer-billing-customer/customer-billing-customer-list/customer-billing-customer-list.component.scss"],"names":[],"mappings":"AACI;EACI,qCAAA;AAAR;AACQ;EACI,gDAAA;AACZ;AAEI;EACI,sCAAA;AAAR;AACQ;EACI,iDAAA;AACZ;AAEI;EACI,2CAAA;AAAR;AACQ;EACI,sDAAA;AACZ","sourcesContent":[".customer-billing-customer-list {\r\n    .list-row-red {\r\n        background-color: var(--fi-color-red);\r\n        &:hover {\r\n            background-color: var(--fi-color-red) !important;\r\n        }\r\n    }\r\n    .list-row-blue {\r\n        background-color: var(--fi-color-blue);\r\n        &:hover {\r\n            background-color: var(--fi-color-blue) !important;\r\n        }\r\n    }\r\n    .list-row-dark-blue {\r\n        background-color: var(--fi-color-dark-blue);\r\n        &:hover {\r\n            background-color: var(--fi-color-dark-blue) !important;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
